import NotFound from "@/src/components/not-found";
import NotFoundSearch from "@/src/components/not-found-search";
import NotFoundSuggestion from "@/src/components/not-found-suggestion";

const NotFoundScreen = () => {
  const criticalFontCSS = `
    @font-face {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      src: url('data:font/woff2;base64,PUT_BASE64_FOR_400') format('woff2');
      font-display: swap;
    }
    @font-face {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      src: url('data:font/woff2;base64,PUT_BASE64_FOR_600') format('woff2');
      font-display: swap;
    }
    @font-face {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 700;
      src: url('data:font/woff2;base64,PUT_BASE64_FOR_700') format('woff2');
      font-display: swap;
    }
    .critical-font {
      font-family: 'Open Sans', Arial, sans-serif;
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: criticalFontCSS }} />
      <div id="content-wrapper" className="critical-font">
        <NotFound />
        <NotFoundSearch />
        <NotFoundSuggestion />
      </div>
    </>
  );
};

export default NotFoundScreen;
